interface SerialValidationResult {
  whid: string;
  organizationId: string;
  inventoryItemId: string;
  serialNumber: string;
  itemNumber: string;
  description: string;
  assetNumber: string;
  serialStatus: string;
  snRepairEligible: string;
}

interface StageSerialData {
  returnHeaderId: string;
  whid: string;
  serialNumber: string;
  itemNumber: string;
  serialStatus: string;
  userId: string;
}

export const constructStageSerialJson = (
  returnHeaderId: string,
  results: SerialValidationResult[],
  userId: string,
  excludeIndex?: number
): string => {
  const serialData: StageSerialData[] = results
    .filter((_, index) => index !== excludeIndex)
    .map(result => ({
      returnHeaderId,
      whid: result.whid,
      serialNumber: result.serialNumber,
      itemNumber: result.itemNumber,
      serialStatus: result.serialStatus,
      userId
    }));

  return JSON.stringify(serialData);
};